package ui.gameplay.networking

import org.ttt.autogenesis.network.*
import kotlinx.serialization.builtins.*

internal fun registerUiSignalClientHandlersRpcHandlers(rpcRegistry : RpcRegistry, target : ui.gameplay.networking.UiSignalClientHandlers)
{

    rpcRegistry.registerTyped(
        method = "ui.activeTurn",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.ActiveTurnData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleActiveTurn(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.agentStream",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.RpcMessage.AgentStreamData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleAgentStream(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.agentWorkStream",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.RpcMessage.AgentWorkStreamData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleAgentWorkStream(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.syncState",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioSyncState.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleAudioSyncState(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.commandClassification",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.CommandClassificationData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleCommandClassification(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.counterPlayPrompt",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.CounterPlayPrompt.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleCounterPlayPrompt(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.dispatchResult",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.DispatchData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleDispatchResult(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.forceShowTurnResolution",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.ForceShowTurnResolutionData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleForceShowTurnResolution(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.gameOver",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.GameOverData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleGameOver(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.judgementResult",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.JudgementEffectData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleJudgementResult(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.loadMapPack",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.MapLoadInstruction.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleLoadMapPack(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.narrativeChunk",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.NarrativeChunkData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleNarrativeChunk(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.narrativeUpdate",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.NarrativeUpdateData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleNarrativeUpdate(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.announceNemesisThreat",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.NemesisThreatAnnouncementData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleNemesisThreatAnnouncement(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.openNeuralLink",
        direction = RpcDirection.CLIENT,
        serializer = kotlin.Boolean.Companion.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleOpenNeuralLink(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.openWidget",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.OpenWidgetData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleOpenWidget(ctx, payload)
        null
    }

    rpcRegistry.register("client.ping", RpcDirection.CLIENT) { ctx, _ ->
        val response = target.handlePing(ctx)
        response?.let { RpcJson.encodeToJsonElement(org.ttt.autogenesis.network.PingResponse.serializer(), it) }
    }

    rpcRegistry.registerTyped(
        method = "ui.prepareStory",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.PrepareStoryData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handlePrepareStory(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.setCommandInteractive",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.CommandInteractiveData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleSetCommandInteractive(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.setLocalPlayer",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.SetLocalPlayerData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleSetLocalPlayer(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.setResolutionStep",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.ResolutionStepData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleSetResolutionStep(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.showMessageBox",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.ShowMessageBoxData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleShowMessageBox(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.summitResult",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.SummitResultData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleSummitResult(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.thinkingUpdate",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.ThinkingUpdateData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleThinkingUpdate(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.announceTurnOrder",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.TurnOrderAnnouncementData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleTurnOrderAnnouncement(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.updateIntent",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.UpdateIntentData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleUpdateIntent(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.updateProgressBar",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.ProgressBarData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleUpdateProgressBar(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.updatePromptStatus",
        direction = RpcDirection.CLIENT,
        serializer = structs.AgentUsage.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleUpdatePromptStatus(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.updateTurnTimer",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.TurnTimerUpdateData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleUpdateTurnTimer(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.updateWorld",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.WorldUpdateData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleUpdateWorld(ctx, payload)
        null
    }
}

internal class UiSignalClientHandlersRpcHandlersRegistrationProvider(private val target : ui.gameplay.networking.UiSignalClientHandlers) : RpcRegistrationProvider
{
    override fun register(rpcRegistry : RpcRegistry)
    {
        registerUiSignalClientHandlersRpcHandlers(rpcRegistry, target)
    }
}

internal val _uiSignalClientHandlersRpcHandlersProvider = UiSignalClientHandlersRpcHandlersRegistrationProvider(ui.gameplay.networking.UiSignalClientHandlers).also {
    RpcRegistrationCollector.registerProvider(it)
}
